<fcom-loader class="block" [title]="'loader.title'" [paragraph]="'oneUpgrade.paymentProcessing'"></fcom-loader>
